import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import MENU from './MENU';

// horizontal listing of multiple menus
export default class MENUBAR extends PureComponent {

    render() {
        return <div className="menu-bar">
            {this.props.menu.map((item, i) => {
                return <div key={i} className="menu-bar-item">{MENU.annotateAccelText(item.text, item.accel)}</div>;
            })}
        </div>;
    }
}


// WEBPACK FOOTER //
// ./src/walleris/menus/MENUBAR.js